export default __webpack_public_path__ + "static/media/book1.003226d7.jpg";